export const common = {
  signIn: "Logga in",
  inbox: "Inkorg",
  create: "Skapa",
  home: "Hem",
  listings: "Annonser",
  myPage: "Min sida",
  close: "Stäng",
  cancel: "Avbryt",
  save: "Spara",
  delete: "Ta bort",
  edit: "Redigera",
  tryAgain: "Försök igen",
  toStartPage: "Till startsidan",
  more: "Mer",
  search: "Sök",
  loading: "Laddar…",
  free: "Gratis",
  price: "Pris",
  kr: "kr",
  sold: "Såld",
  paused: "Pausad",
  today: "Idag",
  yesterday: "Igår",
  unread: "olästa",
  openOnWeb: "Öppna på webben",
  webBanner: "Köp och uppgraderingar görs på sellavo.com",
  quickMenu: "Snabbmeny",
  language: "Språk",
  country: "Land",
  sellCountry: "Säljland",
  sellCountryHint: "Styr var prylen säljs och vilka orter som visas.",
} as const;
